/**
 * Shared styling constants for modal components
 * 
 * These constants ensure consistent styling across all modals in the application,
 * following the Apple-style design patterns.
 */

/**
 * Base className for modal input fields
 * 
 * Includes:
 * - Right-aligned text
 * - Transparent background
 * - No borders or padding
 * - No box-shadow (required for modal inputs)
 * - Consistent typography
 */
export const MODAL_INPUT_BASE_CLASSES =
  "!bg-transparent border-0 p-0 text-[17px] text-gray-900 dark:text-gray-100 font-normal focus:outline-none focus:ring-0 !shadow-none hover:!shadow-none";

/**
 * Complete className for modal text inputs (right-aligned)
 * 
 * Use this for standard Input components in modals
 */
export const MODAL_INPUT_CLASSES = `${MODAL_INPUT_BASE_CLASSES} text-right`;

/**
 * Complete className for modal LinkFieldSearch components (right-aligned)
 * 
 * Use this for LinkFieldSearch components in modals
 */
// NOTE: `pr-7` restores right padding that MODAL_INPUT_BASE_CLASSES' `p-0` strips,
// so the right-aligned text/placeholder clears the dropdown chevron (LinkFieldSearch
// renders a ChevronDown pinned at `right-2.5`). Without it the two overlap.
export const MODAL_LINK_FIELD_SEARCH_CLASSES = `w-full ${MODAL_INPUT_BASE_CLASSES} text-right pr-7`;

/**
 * Complete className for modal inputs with width constraint
 * 
 * Use this when you need to limit the input width to 60%
 */
export const MODAL_INPUT_CONSTRAINED_CLASSES = `flex-1 max-w-[60%] ${MODAL_INPUT_CLASSES}`;

